import { render, staticRenderFns } from "./GestionLimpieza.vue?vue&type=template&id=8b14f174&"
import script from "./GestionLimpieza.vue?vue&type=script&lang=js&"
export * from "./GestionLimpieza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports